var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWallet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 168,
    viewBox: "0 0 168 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.876 89.25H150.634C158.162 89.25 164.919 83.7847 165.677 76.293C166.546 67.6961 159.742 60.375 151.313 60.375H100.572C96.3092 60.375 92.4846 57.183 92.2641 52.9226C92.0252 48.3814 95.6372 44.625 100.126 44.625H113.884C121.412 44.625 128.169 39.1597 128.927 31.668C129.796 23.0711 122.992 15.75 114.563 15.75H84.376H64.6885H25.3135C17.3387 15.75 10.876 22.2127 10.876 30.1875C10.876 38.1623 17.3387 44.625 25.3135 44.625H34.501C37.4016 44.625 39.751 46.9744 39.751 49.875C39.751 52.7756 37.4016 55.125 34.501 55.125H15.37C9.2091 55.125 3.68085 59.598 3.06135 65.7248C2.34997 72.7598 7.9176 78.75 14.8135 78.75H31.4297C35.6927 78.75 39.5173 81.942 39.7379 86.2024C39.9767 90.7436 36.3647 94.5 31.876 94.5H23.245C17.0841 94.5 11.5558 98.973 10.9363 105.1C10.2276 112.135 15.7926 118.125 22.6885 118.125H34.2201C36.8346 118.125 39.2601 119.913 39.6801 122.493C40.213 125.782 37.6903 128.625 34.501 128.625H23.245C17.0841 128.625 11.5558 133.098 10.9363 139.225C10.225 146.26 15.7926 152.25 22.6885 152.25H80.4385C80.6642 152.25 80.8742 152.195 81.0947 152.184C81.3152 152.203 81.5252 152.25 81.751 152.25H127.389C131.773 152.25 135.776 149.305 136.674 145.013C137.905 139.12 133.379 133.875 127.688 133.875H113.532C110.917 133.875 108.492 132.087 108.072 129.507C107.539 126.218 110.062 123.375 113.251 123.375H145.507C151.668 123.375 157.196 118.902 157.816 112.773C158.524 105.74 152.959 99.75 146.063 99.75H137.157C134.542 99.75 132.117 97.9624 131.697 95.382C131.164 92.0929 133.687 89.25 136.876 89.25Z",
    fill: "url(#paint0_radial)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48 59.25V109.25C48 110.908 48.6585 112.497 49.8306 113.669C51.0027 114.842 52.5924 115.5 54.25 115.5H116.75C117.579 115.5 118.374 115.171 118.96 114.585C119.546 113.999 119.875 113.204 119.875 112.375V68.625C119.875 67.7962 119.546 67.0013 118.96 66.4153C118.374 65.8292 117.579 65.5 116.75 65.5H54.25C52.5924 65.5 51.0027 64.8415 49.8306 63.6694C48.6585 62.4973 48 60.9076 48 59.25ZM48 59.25C48 57.5924 48.6585 56.0027 49.8306 54.8306C51.0027 53.6585 52.5924 53 54.25 53H107.375",
    stroke: "#2F189C",
    strokeWidth: 7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.688 95.1875C105.276 95.1875 107.375 93.0888 107.375 90.5C107.375 87.9112 105.276 85.8125 102.688 85.8125C100.099 85.8125 98 87.9112 98 90.5C98 93.0888 100.099 95.1875 102.688 95.1875Z",
    fill: "#2F189C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 40.5,
    y: 49.5,
    width: 86.875,
    height: 77.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.376 84) scale(75.0986)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AFEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.193,
    stopColor: "#BBF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.703,
    stopColor: "#D7F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1FAFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.4c4be345.svg";
export { ForwardRef as ReactComponent };